/* ════════════════════════════════════════
   LIGHTBOX
   ════════════════════════════════════════ */
function initLightbox() {
  var lb      = document.getElementById('cpLightbox');
  var track   = document.getElementById('cpLightboxTrack');
  var counter = document.getElementById('cpLightboxCounter');
  var slides  = lb ? lb.querySelectorAll('.cp-lightbox__slide') : [];
  var total   = slides.length;
  var current = 0;
  var startX  = 0;
  var dragging = false;

  if (!lb || !total) return;

  function goTo(idx) {
    if (idx < 0) idx = 0;
    if (idx >= total) idx = total - 1;
    current = idx;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    if (counter) counter.textContent = (current + 1) + ' / ' + total;
    updateNavButtons();
  }

  function updateNavButtons() {
    var prevBtn = lb.querySelector('.cp-lightbox__nav--prev');
    var nextBtn = lb.querySelector('.cp-lightbox__nav--next');
    if (prevBtn) prevBtn.style.display = current <= 0 ? 'none' : '';
    if (nextBtn) nextBtn.style.display = current >= total - 1 ? 'none' : '';
  }

 function open(idx) {

  var visibleGallery = Array.from(
    document.querySelectorAll('.cp-gallery__slide')
  ).filter(function(s) {
    return s.style.display !== 'none';
  });

  slides.forEach(function(lightboxSlide, i) {

    var img = lightboxSlide.querySelector('img');

    if (visibleGallery[i]) {
      lightboxSlide.style.display = '';
      img.src = visibleGallery[i].querySelector('img').src;
    } else {
      lightboxSlide.style.display = 'none';
    }

  });

  total = visibleGallery.length;

  goTo(idx || 0);

  lb.classList.add('is-open');
  document.body.style.overflow = 'hidden';
  
  lb.querySelector('.cp-lightbox__inner').scrollTop = 0;
}

  function close() {
    lb.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Click gallery slides to open
  document.querySelectorAll('.cp-gallery__slide').forEach(function(slide) {
  slide.addEventListener('click', function() {

    var visibleSlides = Array.from(
      document.querySelectorAll('.cp-gallery__slide')
    ).filter(function(s) {
      return s.style.display !== 'none';
    });

    var idx = visibleSlides.indexOf(slide);

    open(idx < 0 ? 0 : idx);
  });
});

  // Nav buttons
  var prev = lb.querySelector('.cp-lightbox__nav--prev');
  var next = lb.querySelector('.cp-lightbox__nav--next');
  if (prev) prev.addEventListener('click', function(e) { e.stopPropagation(); goTo(current - 1); });
  if (next) next.addEventListener('click', function(e) { e.stopPropagation(); goTo(current + 1); });

  // Close
  lb.querySelector('.cp-lightbox__close').addEventListener('click', close);
  lb.querySelector('.cp-lightbox__inner').addEventListener('click', function(e) {
    if (e.target === lb.querySelector('.cp-lightbox__inner') || e.target.tagName === 'IMG') close();
  });

  // ESC
  document.addEventListener('keydown', function(e) {
    if (!lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') goTo(current - 1);
    if (e.key === 'ArrowRight') goTo(current + 1);
  });

  // Touch swipe
  lb.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    dragging = true;
  }, { passive: true });

  lb.addEventListener('touchend', function(e) {
    if (!dragging) return;
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      goTo(diff > 0 ? current + 1 : current - 1);
    }
    dragging = false;
  }, { passive: true });

  goTo(0);
}

/* ════════════════════════════════════════
   SHIPPING DRAWER
   ════════════════════════════════════════ */
function initShippingDrawer() {
  var drawer   = document.getElementById('cpShipDrawer');
  var overlay  = document.getElementById('cpShipOverlay');
  var closeBtn = document.getElementById('cpShipClose');
  var zipInput = document.getElementById('cpShipZipInput');
  var submit   = document.getElementById('cpShipZipSubmit');
  var rates    = document.getElementById('cpShipRates');
  var zipBtn   = document.getElementById('cpZipBtn');
  var zipDisplay = document.getElementById('cpZipDisplay');

  if (!drawer) return;

  var COUNTRY_NAMES = {
    US:'United States',GB:'United Kingdom',CA:'Canada',AU:'Australia',
    DE:'Germany',FR:'France',IT:'Italy',ES:'Spain',NL:'Netherlands',
    PK:'Pakistan',IN:'India',BD:'Bangladesh',AE:'United Arab Emirates',
    SA:'Saudi Arabia',TR:'Turkey',PL:'Poland',SE:'Sweden',NO:'Norway',
    DK:'Denmark',CH:'Switzerland',AT:'Austria',BE:'Belgium',MX:'Mexico',
    BR:'Brazil',JP:'Japan',KR:'South Korea',SG:'Singapore',MY:'Malaysia',
    NZ:'New Zealand',ZA:'South Africa'
  };

  function openDrawer() {
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (zipInput) zipInput.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (zipBtn) zipBtn.addEventListener('click', function(e) {
    e.preventDefault();
    openDrawer();
  });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  function fetchRates(zip, countryCode, province) {
    var country = COUNTRY_NAMES[countryCode] || countryCode || 'United States';
    var url = '/cart/shipping_rates.json?shipping_address[zip]=' + encodeURIComponent(zip || '') +
              '&shipping_address[country]=' + encodeURIComponent(country) +
              '&shipping_address[province]=' + encodeURIComponent(province || '');

    rates.innerHTML = '<p class="cp-shipping__loading">Fetching rates...</p>';

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var rs = data.shipping_rates;
        if (!rs || !rs.length) {
          rates.innerHTML = '<p>No rates found for this location.</p>';
          return;
        }
        rates.innerHTML = rs.slice(0, 6).map(function(r) {
          var price = parseFloat(r.price) === 0 ? 'FREE' : '$ ' + parseFloat(r.price).toFixed(2);
          return '<p>' + r.name.toUpperCase() + ': ' + price + '</p>';
        }).join('');
      })
      .catch(function() {
        rates.innerHTML = '<p>Could not fetch rates. See checkout for options.</p>';
      });
  }

  if (submit) {
    submit.addEventListener('click', function() {
      var zip = zipInput ? zipInput.value.trim() : '';
      if (!zip) return;
      var country = sessionStorage.getItem('cp_country') || 'US';
      var prov    = sessionStorage.getItem('cp_province') || '';
      sessionStorage.setItem('cp_zip', zip);
      if (zipDisplay) zipDisplay.textContent = zip;
      fetchRates(zip, country, prov);
    });
    if (zipInput) {
      zipInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') submit.click();
      });
    }
  }

  // Auto-load with cached or detected location
  var cachedZip     = sessionStorage.getItem('cp_zip');
  var cachedCountry = sessionStorage.getItem('cp_country');
  var cachedProv    = sessionStorage.getItem('cp_province');

  if (cachedCountry && rates) {
    if (zipInput) zipInput.value = cachedZip || '';
    fetchRates(cachedZip || '', cachedCountry, cachedProv || '');
  }

  // ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initLightbox();
  initShippingDrawer();
});
